var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.targetComponent(),{tag:"component",attrs:{"brandConfig":_vm.brandConfig,"country":_vm.country,"storeId":_vm.storeId,"storeName":_vm.storeName,"txNo":_vm.txNo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }